import Context from "@/context/Context";
import Store from "@/redux/store";
import React from "react";
import { Provider } from "react-redux";
import Link from "next/link";


import HeaderStyleTen from "@/components/Header/HeaderStyle-Ten";
import MobileMenu from "@/components/Header/MobileMenu";
import Cart from "@/components/Header/Offcanvas/Cart";
import PageHead from "@/pages/Head";
import BackToTop from "@/pages/backToTop";
import PricingThree from "@/components/Pricing/Pricing-Three";
import FooterOne from "@/components/Footer/Footer-One";

const SubscriptionPage = () => {
  return (
    <>
      <PageHead title="Learning King - Subscription" />

      <Provider store={Store}>
        <Context>
          <HeaderStyleTen headerSticky="rbt-sticky" headerType="" />
          <MobileMenu />
          <Cart />
          <BreadCrumb title="Membership Subscription" text="Subscription" />

          <div className="rbt-pricing-area bg-color-white rbt-section-gap">
            <PricingThree title="" tag="" col="col-12" position="text-center" />
          </div>

          <div className="rbt-accordion-area accordion-style-1 bg-color-extra2 rbt-section-gap">
            <AccordionThree />
          </div>

          <BackToTop />
          <FooterOne bgColor="bg-color-darker" />
        </Context>
      </Provider>
    </>
  );
};

const AccordionThree = () => {

  const accordionThree = {
    "AccordionThree": [
      {
        "tag": "faq",
        "title": "Have a Question with ",
        "subTitle": " Our Membership Subscription?",
        "strong": "",
        "description": "LearningKing Membership comes in three levels including; Wealth Minds Plan, Smart Employee and Advanced Learner. The benefits of our membership plans by far outweigh the cost of subscription giving you an opportunity to advance your skills at your convenience and within your budget. Select your plan, complete subscription and start your journey of success with new skills from our off-shelf and tailored training programs.",
        "faqBody": [
          {
            "collapse": "collapseOne3",
            "heading": "headingOne3",
            "expanded": true,
            "collapsed": true,
            "show": true,
            "accordionTitle": "How does LearningKing Membership Work?",
            "desc": "Our Membership is an annual subscription which gives you access to a given number of paid courses including the free ones. This subscription expires after twelve months and should be renewed for continued studies."
          },
          {
            "collapse": "collapseTwo3",
            "heading": "headingTwo3",
            "expanded": false,
            "collapsed": false,
            "show": false,
            "accordionTitle": "What Membership Subscription Plans are available?",
            "desc": "We have three membership plans including the Wealthy Minds Plan, Smart Employee and Advanced Learner. "
          },
          {
            "collapse": "collapseThree3",
            "heading": "headingThree3",
            "expanded": false,
            "collapsed": false,
            "show": false,
            "accordionTitle": "What is included in the Membership Subscription Plans?",
            "desc": "The Wealthy Minds Plan gives you access to two courses under the Wealthy Minds Academy. Smart Employee gives you access to everything under the Wealthy Minds Plan as well as two corporate courses under Professional Training. Lastly, the Advanced Learner Plan offers everything under the Smart Employee Plan plus two Advanced Courses under Professional Training."
          },
          {
            "collapse": "collapseFour3",
            "heading": "headingFour3",
            "expanded": false,
            "collapsed": false,
            "show": false,
            "accordionTitle": "How do I Purchase a LearningKing Membership?",
            "desc": "On the membership page, select your suitable subscription plan and click subscribe. Follow the simple payment steps until you receive a successful payment notification. You will receive an email notification of your active membership plan. With an active plan, you can search for your desired courses available under that plan and get enrolled."
          },{
            "collapse": "collapseFive3",
            "heading": "headingFive3",
            "expanded": false,
            "collapsed": false,
            "show": false,
            "accordionTitle": "Can I purchase membership for many learners at once?",
            "desc": "Yes, you can. In the process of completing your subscription payment, you will be given the option to buy a single subscription or bulk purchase. Select the Bulk Purchase option and follow the simple steps."
          },
          {
            "collapse": "collapseSix3",
            "heading": "headingSix3",
            "expanded": false,
            "collapsed": false,
            "show": false,
            "accordionTitle": "Can I upgrade my Membership Plan?",
            "desc": "Yes, you can. At any one point in time and depending on the duration of the current plan, you can choose to advance to the next plan. With an active plan, you will be able to see the Option to Upgrade to any of the next plans."
          }
        ],
        "faqBody2": [
          {
            "collapse": "collapseOne4",
            "heading": "headingOne4",
            "expanded": true,
            "collapsed": true,
            "show": true,
            "accordionTitle": "What is Histudy ? How does it work?",
            "desc": "You can run Histudy easily. Any School, University, College can be use this histudy education template for their educational purpose. A university can be run their online leaning management system by histudy education template."
          },
          {
            "collapse": "collapseTwo4",
            "heading": "headingTwo4",
            "expanded": false,
            "collapsed": false,
            "show": false,
            "accordionTitle": "10 Brilliant Ways To Advertise Education",
            "desc": "After purchasing the product need you any support you can be share with us with sending mail to rainbowit10@gmail.com."
          },
          {
            "collapse": "collapseThree4",
            "heading": "headingThree4",
            "expanded": false,
            "collapsed": false,
            "show": false,
            "accordionTitle": "7 Facts About Education That Will Blow",
            "desc": "Yes, We will get update the Histudy. And you can get it any time. Next time we will comes with more feature. You can be get update for unlimited times. Our dedicated team works for update."
          },
          {
            "collapse": "collapseFour4",
            "heading": "headingFour4",
            "expanded": false,
            "collapsed": false,
            "show": false,
            "accordionTitle": "15 Things To Know About Education?",
            "desc": "If you're looking for random paragraphs, you've come to the right place. When a random word or a random sentence isn't quite enough, the next logical step is to find a random paragraph."
          }
        ]
      }
    ]
  }

  return (
    <div className="container">
      {accordionThree.AccordionThree.map((data, index) => (
        <div className="row g-5 align-items-center" key={index}>
          <div className="col-lg-10 offset-lg-1">
            <div className="rbt-accordion-style accordion">
              <div className="section-title mb--60">
                <div className="text-center">
                  <span className="subtitle bg-pink-opacity">{data.tag}</span>
                </div>
                <h2 className="title text-center">
                  {data.title} <br /> {data.subTitle}
                </h2>
                <p className="description has-medium-font-size mt--20">
                  <strong>{data.strong}</strong> {data.description}
                </p>
              </div>
              <div className="rbt-accordion-style rbt-accordion-04 accordion">
                <div className="accordion" id="accordionExamplec3">
                  {data.faqBody.map((item, innerIndex) => (
                    <div className="accordion-item card" key={innerIndex}>
                      <h2
                        className="accordion-header card-header"
                        id={item.heading}
                      >
                        <button
                          className={`accordion-button ${!item.collapsed ? "collapsed" : ""
                            }`}
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target={`#${item.collapse}`}
                          aria-expanded={item.expanded}
                          aria-controls={item.collapse}
                        >
                          {item.accordionTitle}
                        </button>
                      </h2>
                      <div
                        id={item.collapse}
                        className={`accordion-collapse collapse ${item.show ? "show" : ""
                          }`}
                        aria-labelledby={item.heading}
                        data-bs-parent="#accordionExamplec3"
                      >
                        <div className="accordion-body card-body">
                          {item.desc}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

const BreadCrumb = ({ title, text }) => {
  return (
    <div className="rbt-breadcrumb-default ptb--100 ptb_md--50 ptb_sm--30 bg-gradient-1">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <div className="breadcrumb-inner text-center">
              <h2 className="title">{title}</h2>
              <ul className="page-list">
                <li className="rbt-breadcrumb-item">
                  <Link href="/">Home</Link>
                </li>
                <li>
                  <div className="icon-right">
                    <i className="feather-chevron-right"></i>
                  </div>
                </li>
                <li className="rbt-breadcrumb-item active">{text}</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionPage;
